export var ProjectAllIntegrationsItemViewType;
(function (ProjectAllIntegrationsItemViewType) {
    ProjectAllIntegrationsItemViewType["ProjectDynamicSnippet"] = "projectDynamicSnippet";
    ProjectAllIntegrationsItemViewType["Integration"] = "integration";
})(ProjectAllIntegrationsItemViewType || (ProjectAllIntegrationsItemViewType = {}));
export var ProjectAllIntegrationsStatus;
(function (ProjectAllIntegrationsStatus) {
    ProjectAllIntegrationsStatus["Pending"] = "Pending";
    ProjectAllIntegrationsStatus["TurnedOn"] = "Turned On";
    ProjectAllIntegrationsStatus["TurnedOff"] = "Turned Off";
})(ProjectAllIntegrationsStatus || (ProjectAllIntegrationsStatus = {}));
//# sourceMappingURL=project-all-integrations.js.map